import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './config/auth.guard';

let currentCompanyId: string | null = null
let company = JSON.parse(localStorage.getItem('currentCompany'));
currentCompanyId = company ? company._id : null


const routes: Routes = [
  { path: '**', redirectTo: `client-dashboard/${currentCompanyId}`}// , canActivate: [AuthGuard] },
  //{ path: '**', redirectTo: 'dashboard' }    
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
